<template>
  <section>
    <h4 class="fs-20 font-medium mb-4">
      Programme Inclusions
    </h4>

    <checkbox
      v-for="incl in essentialInclusions"
      :key="incl.id"
      v-model="options.facilitiesOptions[`opt${incl.id}`]"
      @change="$emit('filter-changed')">
      {{ incl.name }}
    </checkbox>

    <h4 class="fs-20 font-medium mb-4 mt-6">
      Dive Course Inclusions
    </h4>

    <checkbox
      v-for="incl in diveCoursesInclusions"
      :key="incl.id"
      v-model="options.facilitiesOptions[`opt${incl.id}`]"
      @change="$emit('filter-changed')">
      {{ incl.name }}
    </checkbox>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import Checkbox from '../../core/Checkbox'
import {
  ECOVENTURE_BASIC_INCLUSIONS
} from '../../../helpers/constants'

export default {
  components: {
    Checkbox
  },
  inject: ['options'],
  computed: {
    ...mapGetters(['availableInclusions']),
    essentialInclusions () {
      return ECOVENTURE_BASIC_INCLUSIONS.filter(incl => {
        return incl.is_essential
      })
    },
    diveCoursesInclusions () {
      return ECOVENTURE_BASIC_INCLUSIONS.filter(incl => {
        return incl.is_dive_course_inclusion
      })
    }
  }
}
</script>